import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;



// WEBPACK FOOTER //
// ./src/index.js